import { FC } from 'react';

import { FormTabs } from 'components';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';

import { LegalClientLegalHeadSectionsProps } from './types';
import { useLegalClientLegalHeadSections } from './useLegalClientLegalHeadSections';

export const LegalClientLegalHeadSections: FC<
  LegalClientLegalHeadSectionsProps
> = ({ countryRiskAt, ...props }) => {
  const { tabs } = useLegalClientLegalHeadSections(props);

  return (
    <CountryRiskProvider
      at={countryRiskAt}
      role={CountryRiskRole.LegalClientLegalHead}
    >
      <FormTabs tabs={tabs} />
    </CountryRiskProvider>
  );
};
